/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
import { url } from 'utils/urls'
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { Button } from '@insticator/insticator-ui'
// styles
import injectSheet from 'react-jss'
import styles from './addetails_styles'
import { useSelector } from 'react-redux'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADS SECTION : AD DETAILS ~~~~~~~~~~ ========== */
const AdDetails = injectSheet(styles)((props) => {
  const { visibility } = props
  const { siteUUID } = useSelector((state) => state.session)
  return (
    <div id="ads-config">
    <SectionGroupV2 
      klass={`addetails ${props.classes.addetails}`}
      title={'Ad settings'} 
      description={`Create and manage ad settings through the admin panel`}
      disabled={visibility === 'NONE'}
    >
       <Button
          klass={'configbutton'}
          variant={'system'}
          text={'Configure'}
          handleClick={() => {
            window.open(url.embed.admin.url + '/managesite?siteUUID=' + siteUUID + '&source=ppa' , '_blank')
          }}
        />  
    </SectionGroupV2>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdDetails;